import gql from 'graphql-tag';

export const ADD_CUSTOM_WORKLETS = gql`
  mutation AddCustomWorkletsMutation($taskNames: [String!]!) {
    specKeys: addCustomWorklets(taskNames: $taskNames)
  }
`;
